var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhmoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_923)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.341 33.8934C41.2448 33.797 41.1242 33.7286 40.9921 33.6955C40.8599 33.6625 40.7213 33.6661 40.591 33.7059C39.161 34.1382 37.6404 34.1745 36.1913 33.8108C34.7422 33.4471 33.419 32.697 32.3626 31.6406C31.3061 30.5842 30.5561 29.2609 30.1924 27.8119C29.8287 26.3628 29.865 24.8422 30.2973 23.4121C30.3374 23.2818 30.3413 23.143 30.3084 23.0107C30.2756 22.8784 30.2073 22.7575 30.1108 22.6611C30.0144 22.5647 29.8936 22.4964 29.7612 22.4635C29.6289 22.4307 29.4901 22.4345 29.3598 22.4746C27.3826 23.0803 25.6469 24.2941 24.3995 25.9434C23.3086 27.3917 22.6432 29.1155 22.478 30.9211C22.3129 32.7267 22.6545 34.5426 23.4644 36.1648C24.2744 37.787 25.5207 39.1512 27.0632 40.1041C28.6058 41.0571 30.3835 41.561 32.1967 41.5593C34.312 41.5658 36.371 40.8782 38.0579 39.6018C39.7072 38.3544 40.921 36.6187 41.5267 34.6415C41.5663 34.5117 41.57 34.3735 41.5373 34.2418C41.5046 34.11 41.4368 33.9896 41.341 33.8934ZM37.156 38.4037C35.5675 39.6002 33.6002 40.1826 31.6163 40.0437C29.6324 39.9047 27.7655 39.0539 26.3592 37.6477C24.9529 36.2415 24.1018 34.3746 23.9628 32.3907C23.8237 30.4069 24.4059 28.4395 25.6023 26.8509C26.3817 25.8215 27.3894 24.9872 28.546 24.4134C28.4802 24.8758 28.447 25.3422 28.4467 25.8093C28.4494 28.3943 29.4775 30.8727 31.3054 32.7006C33.1333 34.5285 35.6117 35.5566 38.1967 35.5593C38.6647 35.5592 39.1321 35.526 39.5954 35.4599C39.0211 36.6168 38.186 37.6245 37.156 38.4037Z",
    fill: "#0B0909"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_923",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_923",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhmoon);
export default __webpack_public_path__ + "static/media/phmoon.8e5d3ef3aa0e48c60efa3a3d50a789d2.svg";
export { ForwardRef as ReactComponent };